import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-booking-details-door-step-display',
  templateUrl: './booking-details-door-step-display.component.html',
  styleUrls: ['./booking-details-door-step-display.component.scss']
})

export class BookingDetailsDoorStepDisplayComponent implements OnInit {

  @Input()
  appCopy = null;

  @Input()
  selectedLanguage = null;
  
  @Input() extraBagDoorstepPayment;
  @Input() currencySymbol;
  constructor() { }

  ngOnInit() {
  }

}
